import PropTypes from 'prop-types';
const Records = (props) => {
  const { items, cols = 1 } = props;
  return (
    <tbody>
      {items.length > 0 ? (
        items
      ) : (
        <tr className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
          <td colSpan={cols} className="px-6 py-4 text-center">
            No hay registros
          </td>
        </tr>
      )}
    </tbody>
  );
};

Records.propTypes = {
  items: PropTypes.array.isRequired,
  cols: PropTypes.number
};

export default Records;
